<template>
  <!-- <van-tabbar v-model="actindex" active-color="#FF610D" @change="jump">
    <van-tabbar-item to="/" icon=" iconfont icon-shouye2">标签</van-tabbar-item>
    <van-tabbar-item to="/goods_sort" icon=" iconfont icon-fenlei1">标签</van-tabbar-item>
    <van-tabbar-item to="/scan" icon=" iconfont icon-fenlei1">标签</van-tabbar-item>
    <van-tabbar-item to="/ShopCart" icon=" iconfont icon-gouwuche">标签</van-tabbar-item>
    <van-tabbar-item to="/Personal" icon=" iconfont icon-wode">标签</van-tabbar-item>
  </van-tabbar> -->
  <div>
    <van-tabbar style="z-index:999;">
      <van-tabbar-item  :class="actindex==i.link?'TabbarActive':'TabbarUnActive'" :to="i.link" :info="i.info" @click="redirectToMenu(i)" v-for="(i,index) in tablist" :key="index" :icon="i.icon">{{i.name}}</van-tabbar-item>
    </van-tabbar>
  </div>
  <!-- <van-tabbar-item v-for="(item,index) in tabbars" :key="index" @click="tab(index,item.name)">
      <span :class="path == item.name ? 'span_active':''">{{item.title}}</span>
      <template slot="icon" slot-scope="props">
        <img :src="path == item.name ? item.active : item.normal">
      </template>
    </van-tabbar-item>
  </van-tabbar> -->

</template>

<script>
import { Tabbar, TabbarItem, Dialog} from "vant";
export default {
  name: 'tabbar',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Dialog.name]: Dialog,
  },
  props: ['cart_quantity'],
  data () {
    return {
      goodsALLcount: '',
      tablist: [
        { name: '首页', link: '/', icon: ' iconfont icon-shouye2', index: 0 },
        { name: '分类', link: '/IdxClassify', icon: ' iconfont icon-fenlei1', index: 1 },
        { name: '扫码', icon: ' iconfont icon-saomiao', index: 2 },
        { name: '购物车', link: '/defaultShoplist', icon: ' iconfont icon-gouwuche', index: 3, info: '' },
        { name: '我的', link: '/personal', icon: ' iconfont icon-wode', index: 4 },
      ],
      actindex: '',
      path: '',
    }
  },
  watch:{
    'cart_quantity':{
      handler: function handler (newVal, oldVal) {
        this.tablist[3].info = newVal;
      }
    }
  },
  created(){
    // console.log(this.cart_quantity,'footer')
  },
  mounted () {
    var that = this;
    that.actindex = this.$router.currentRoute.path;
    that.count();
  },
  methods: {
    redirectToMenu(i) {
        this.jump(i.link,i.index)
        this.$emit('hidePopup')
    },
    count () {
      var that = this;
      that.$get('api/cart/cart_count', { token: localStorage.getItem('token') }).then(result => {
        that.tablist[3].info = result.data.data;
      })
    },
    jump (link, index) {
      this.actindex = link;
      if (index == '2') {
        this.getSDKprd();
      }
    },
    tab (index, val) {
      this.currIndex = index;
      this.$router.push(val);
    },
    sdkSearchDeatail (order_no) {

    },
    getSDKprd () {
      var that = this;
      that.$post('/api/sm/jsapi', { token: localStorage.getItem('token') }).then(result => {
        var _data = result.data;
        var js_api_data = _data.data;
        if (_data.code == '200') {
          that.getScanCode(js_api_data)
        }
      }).catch(error => {
        console.log(error, 'Error')
      })
    },
    getScanCode (_data) {
      var that = this;
      wx.config({
        debug: false,
        appId: _data.appId,
        timestamp: _data.timestamp,
        nonceStr: _data.nonceStr,
        signature: _data.signature,
        jsApiList: ["scanQRCode"]
      });
      wx.ready(() => {
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function (res) {
              if(res.resultStr.indexOf('http') == -1){
                  var serial = res.resultStr.split(",");
                  var barCode = serial[serial.length - 1];
                  let order_no = barCode;
                  that.$post('/api/Sm/index', { itemcode: order_no }).then(result => {
                      if (result.data.code == '200') {
                          //1为单个商品.跳转详情
                          console.log(result.data)
                          if (result.data.type == 1) {
                              that.$router.push({ path: '/productdetail', query: { itemcode: result.data.itemcode } })
                          } else if (result.data.type == 2) {//2为多个商品跳转类似搜索页面.
                              that.$router.push({ path: '/smsearch', query: { itemcode: result.data.itemcode } })
                          }
                      } else {
                          that.$tip("暂无此条码商品")
                          that.$router.push("/error")
                          // that.$confirm('暂无此条码商品', '确定').then(action => {
                          //   if (action == 'confirm') {
                          //     that.$router.replace('/')
                          //   } else {
                          //     that.$router.replace('/')
                          //   }
                          // })
                      }
                  }).catch(error => {
                      console.log(error, 'Error')
                  })
              }else{
                  return Dialog.alert({
                      title: '提示',
                      message: '请扫条形码',
                  }).then(() => {
                      // this.$router.go(-1)
                  });
              }

            // } else {
            //   // var url = '/wap/400.html';
            //   that.$router.push("/error")
            // }
          },
          error: function (err) {
            console.log(err);
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.TabbarActive {
  color: #ff610d !important;
}
.TabbarUnActive {
  color: #7d7e80 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/footer.vue